import styled from "styled-components"

import { DefaultStyle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"

export const Empty = styled.div``

export const StyledDiscount = styled.div<ItemRenderProps>`
  ${DefaultStyle.itemCss};
`

export const Name = styled.div`
  ${DefaultStyle.nameCss};
`
